/**
 * Conversation lastSeen — Family (Bug 10 fix, Oturum 7)
 *
 * Client-side per-conversation "last opened" timestamp. CLAUDE.md §6.4 — no
 * read receipts on the wire (server doesn't know), but the UI needs to know
 * which conversations have unseen messages so the ContactList can bold the
 * preview and draw the unread dot.
 *
 * Stored in localStorage as ISO timestamp:
 *   family.lastSeen.<conversationId>  →  "2026-05-19T15:30:00.000Z"
 *
 * Chat.tsx writes on mount + on every new message render. ContactList reads
 * during render to compare against the latest message's created_at.
 */

function lastSeenKey(conversationId: string): string {
  return `family.lastSeen.${conversationId}`;
}

export function markConversationSeen(conversationId: string): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(lastSeenKey(conversationId), new Date().toISOString());
}

export function readLastSeen(conversationId: string): Date | null {
  if (typeof localStorage === 'undefined') return null;
  const raw = localStorage.getItem(lastSeenKey(conversationId));
  if (!raw) return null;
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? null : d;
}
